module.exports = __webpack_public_path__ + "static/media/editDetail.15c3e8df.svg";